module.exports = "<mb-notification ng-repeat=\"notification in vm.notificationsStack\"\n                 notif=\"notification\"\n                 close-notification=\"vm.closeNotification(id, config)\"\n                 notification-stack=\"vm.notificationsStack\">\n</mb-notification>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/top-notifications/templates/top-notifications.template.html
// module id = 168
// module chunks = 0